export default __webpack_public_path__ + "static/media/rain-snow.0007ef36.svg";